import findIndex from 'lodash/findIndex.js';
import sortBy from 'lodash/sortBy.js';

export default {
    state: {
        uuid: null,

        activePage: null,
        createdPages: [],
    },

    getters: {
        pages(state, getters, rootState, rootGetters) {
            if (!state.namespace || !state.uuid) return [];

            const activityContent = rootGetters[`${state.namespace}/${state.uuid}/get`]('activity_content');

            const existingPages = Array.isArray(activityContent) ? activityContent : [];

            return sortBy([...existingPages, ...state.createdPages], 'order');
        },
    },

    actions: {
        init({ commit }, { namespace, uuid }) {
            commit('INIT', { namespace, uuid });
        },

        save(context) {},
    },

    mutations: {
        INIT(state, { namespace, uuid }) {
            state.namespace = namespace;
            state.uuid = uuid;
        },

        EDIT_CONTENT_PAGE_ORDER(state, { uuid, id, order }) {
            const index = findIndex(state[uuid].activity_content, page => page.id === id);

            state[uuid].activity_content[index].order = order;
        },
    },
};
